import { render, staticRenderFns } from "./quality-guarantees.vue?vue&type=template&id=7804ea48&scoped=true"
import script from "./quality-guarantees.vue?vue&type=script&lang=js"
export * from "./quality-guarantees.vue?vue&type=script&lang=js"
import style0 from "./quality-guarantees.vue?vue&type=style&index=0&id=7804ea48&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7804ea48",
  null
  
)

export default component.exports